import styled from 'styled-components';
import FormControlLabel from '@mui/material/FormControlLabel/FormControlLabel';

export const AreaButtons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 1rem;
`;

export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: auto;
  gap: 1rem;

  > ${AreaButtons} {
    grid-column: 3 / 3;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.desktopSmall}) {
    grid-template-columns: repeat(2, 1fr);

    > ${AreaButtons} {
      grid-column: 2/2;
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    display: flex;
    flex-direction: column;

    > ${AreaButtons} {
      flex-direction: column;

      > button {
        width: 100%;
        max-width: 100%;
      }
    }
  }
`;

export const AreaCheckbox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
    &[data-compact] {
        gap: 2.3rem;
      }

  @media (max-width: ${({ theme }) => theme.breakpoints.desktopSmall}) {
    display: block;
    gap: 0.5rem;
  }
    
  @media (min-width: ${({ theme }) => theme.breakpoints.desktopWide}) {
    &[data-compact] {
      gap: 9rem;
    }
  }
`;

export const FavoriteSearchLabel = styled(FormControlLabel)`
  && .MuiFormControlLabel-label {
    white-space: nowrap;
  }
`;

export const PredefinedSearchLabel = styled(FormControlLabel)`
  && .MuiFormControlLabel-label {
    white-space: nowrap;
  }
`;

export const AutoCompleteWrapper = styled.div`
  position: relative;
  height: 40px;
`;

export const Title = styled.h6`
  font-weight: bold;
  font-size: 20;
`;